<div class="toast-container">
  @for (toast of toasts(); track toast.id) {
    <div
      class="custom-toast"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      [@toastAnimation]
      (click)="removeToast(toast.id)">
      <custom-icon [name]="getToastIcon(toast)" [color]="getToastColor(toast)" [size]="24" [viewBox]="'0 0 24 24'" />

      <div class="toast-content">
        <div class="toast-message">{{ toast.message }}</div>
      </div>
      <button type="button" class="btn btn-icon" aria-label="Close" (click)="removeToast(toast.id); $event.stopPropagation()">
        <custom-icon name="close" [size]="20" />
      </button>

      <!-- Progress bar -->
      @if (toast.timeout) {
        <div
          class="toast-progress"
          [style.animation-duration.ms]="toast.timeout"
          [style.background-color]="getToastColor(toast)"></div>
      }
    </div>
  }
</div>
